import { Stack, Title, Text, Space } from '@mantine/core';
import { IconCalendarOff } from '@tabler/icons-react';
import { useApp } from '../../../../context/AppContext';
import { useMemo } from 'react';

export const NoBookings = ({ isPastBooking }: { isPastBooking: boolean }) => {
  const { profile } = useApp();

  const message = useMemo(() => {
    if (isPastBooking) {
      return undefined;
    }
    if (profile?.isProfessional) {
      return 'Once you make or receive a booking, it will appear here for you to manage.';
    }
    return 'Once you make a booking, it will appear here for you to manage.';
  }, [profile?.isProfessional]);

  return (
    <Stack
      align="center"
      justify="center"
      p="md"
      data-testid={
        isPastBooking
          ? 'subtitle-no-bookings-past'
          : 'subtitle-no-bookings-upcoming'
      }
    >
      <Space h="xl"></Space>
      <IconCalendarOff size={54} color="#999999" />
      <Title order={4} fw="normal" c="#666666" ta="center">
        You have no {isPastBooking ? 'past' : 'upcoming'} bookings.
      </Title>
      <Text c="#888888" ta="center">
        {message}
      </Text>
    </Stack>
  );
};
